import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";


export  class UnaryExpression extends FRBase{
    private Subtype:string;
    private Expression:FRBase;

    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);
        this.Subtype=Options.St;
        this.Expression=FRFactory.GetFRElement(this.Options.d,this);
    }

    Parse(): any {
        return this.MaybeExecutePromise(this.Expression.Parse(),result=> !result);
    }

}

FRFactory.AddField('UE',UnaryExpression);